import { createApp } from 'vue'
import App from './App.vue'
import "./assets/bootstrap-grid.css";

createApp(App).mount('#app')
